export default __webpack_public_path__ + "static/media/116.d72be663.png";